import dayjs from '@/plugins/dayjs';

export const fileSize = function (num) {
  if (typeof num === 'string') num = parseFloat(num);
  if (isNaN(num) || !num) return ``;

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? '-' : '') + num + ' ' + unit;
};
const textMixin = {
  filters: {
    capitalize(str) {
      if (!str) return '';
      str = str.toLowerCase();
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    nozeroes(str) {
      if (!str) return '';
      return parseFloat(str);
    },
    deCamelCase(str) {
      if (!str) return '';
      str = str.toString();
      const toUppercase = (str) => str.toUpperCase();
      return str.replace(/[A-Z]/g, ' $&').replace(/^./, toUppercase);
    },
    unixTimeToLocal(time) {
      return `${dayjs.unix(time).format('l')} ${dayjs.unix(time).format('LT')}`;
    },
    percent(value, round = 2) {
      if (!value) return `${0}%`;
      else return `${+parseFloat(value).toFixed(round)}%`;
    },
    components: function (components) {
      if (!components.length) return '';
      return components.map((c) => c.componentId.tagName).join(', ');
    },
    stringToSlug(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
      var to = 'aaaaaeeeeiiiioooouuuunc------';

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

      return str;
    },
    fileSize
    // https://github.com/freearhey/vue2-filters
    /* ,
    currency(value, symbol, decimals, options) {
      const digitsRE = /(\d{3})(?=\d)/g;
      options = options || {};
      value = parseFloat(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      symbol = symbol != null ? symbol : '$';
      decimals = decimals != null ? decimals : 2;
      const thousandsSeparator =
        options.thousandsSeparator != null ? options.thousandsSeparator : ',';
      const symbolOnLeft =
        options.symbolOnLeft != null ? options.symbolOnLeft : true;
      const spaceBetweenAmountAndSymbol =
        options.spaceBetweenAmountAndSymbol != null
          ? options.spaceBetweenAmountAndSymbol
          : false;
      let stringified = Math.abs(value).toFixed(decimals);
      stringified = options.decimalSeparator
        ? stringified.replace('.', options.decimalSeparator)
        : stringified;
      const _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
      const i = _int.length % 3;
      const head =
        i > 0
          ? _int.slice(0, i) + (_int.length > 3 ? thousandsSeparator : '')
          : '';
      const _float = decimals ? stringified.slice(-1 - decimals) : '';
      symbol = spaceBetweenAmountAndSymbol
        ? symbolOnLeft
          ? `${symbol} `
          : ` ${symbol}`
        : symbol;
      symbol = symbolOnLeft
        ? symbol +
          head +
          _int.slice(i).replace(digitsRE, `$1${thousandsSeparator}`) +
          _float
        : head +
          _int.slice(i).replace(digitsRE, `$1${thousandsSeparator}`) +
          _float +
          symbol;
      const sign = value < 0 ? '-' : '';
      return sign + symbol;
    },

    */
  }
};

export { textMixin as default };
